import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import { FieldsService } from '../../services/fields.service';
import { allInventoryActionTypes } from './../../../models/inventory_action.model';
import { toUnderscore } from './../../../utils/string-utils';
import { FormBuilder } from '@angular/forms';
import { StatusesService } from '../../services/statuses.service';
import { catchError, debounceTime, EMPTY } from 'rxjs';

@Component({
    selector: 'app-admin-inventory',
    templateUrl: './admin-inventory.component.html',
    styleUrls: ['./admin-inventory.component.scss', '../admin-main.common.scss'],
    standalone: false
})
export class AdminInventoryComponent implements OnInit {

  private readonly fb = inject(FormBuilder);

  public companyForm = this.fb.group({
    preferences: this.fb.group({
      'inventory_action/consume': this.fb.group({
        'automatic_consumption_completion': this.fb.control(false),
        'start_status_ids': this.fb.control([]),
        'finish_status_ids': this.fb.control([]),
      })
    }),
  });

  public inventoryActionTypes: string[] = allInventoryActionTypes;
  
  public loading = false;
  
  public selectedInventoryActionType: string = 'InventoryAction::Stock';

  private readonly companyService = inject(AdminService);

  private readonly statusService = inject(StatusesService);
  
  public orderStatuses = this.statusService.statuses('Status::Order');

  public budgetStatuses = this.statusService.statuses('Status::Budget');
  
  constructor(
    private cdr: ChangeDetectorRef,
    public fieldsService: FieldsService,
  ) { }

  ngOnInit(): void {
    this.companyService.setupApp().pipe(
      catchError((error) => {
        console.error(error);
        return EMPTY;
      })
    ).subscribe((response) => {
      this.companyForm.patchValue(response.body);
    });

    this.companyForm.valueChanges.pipe(debounceTime(2000)).subscribe((value) => {
      if (this.companyForm.valid) {
        this.companyService.updateCompany(value).subscribe();
      }
    });
  }

  underscore(value: string): string {
    return toUnderscore(value);
  }

  onTypeSelected(): void {
    this.cdr.markForCheck();
    this.loading = true;
    setTimeout(() => {
      this.cdr.markForCheck();
      this.loading = false;
    }, 50);
  }
}